// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5e131e38]:export {\n  green: #67c892;\n  green-light: #9ec867;\n  yellow: #edc84c;\n  orange: #e9ad6a;\n  red: #e96a6a;\n  secondaryColor: #30415d;\n  primaryColor: #5dbfe2;\n  primaryColorDark: #4886a5;\n  gray: #a1a1a1;\n}\n.comment-grid[data-v-5e131e38] {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(100px, 1fr));\n  grid-gap: 10px;\n  grid-auto-rows: 8px;\n  margin-left: 3px;\n  margin-right: 3px;\n}", ""]);
// Exports
module.exports = exports;
